import { CalendarHeaderComponent } from './calendar-header/calendar-header.component';
// tslint:disable-next-line:no-duplicate-imports
import { DateTime } from 'luxon';

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Host,
  Input, OnChanges,
  OnInit,
  Optional,
  Output, SimpleChanges,
  SkipSelf,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { AbstractControl, ControlContainer, ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LuxonDateAdapter } from 'src/app/modules/shared/services/luxon-date-adapter';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/modules/shared/components/confirm-dialog/confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-bdc-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BdcCalendarComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default
})
export class BdcCalendarComponent implements ControlValueAccessor, OnInit, OnChanges {
  @ViewChild('tdcalendar', { static: false }) calendar: MatCalendar<DateTime>;
  
  @Input() formControlName: string;
  @Input() isAvailabilityLoading: boolean;
  @Input() availableDates: string[]; // = ['2020-07-21', '2020-07-22', '2020-08-01', '2020-08-05'];
  @Input() startAt; // = '2020-08-20';
  @Input() minDate; // = '2020-07-20';
  @Input() maxDate; // = '2020-09-24';
  @Input() selectedDate: DateTime;
  @Input() source: string;
  @Input() addLeaveService: any; 
  @Input() closedDates : any[] = [];
  @Input() currentMonth: any;
  @Output() dateChanged: EventEmitter<DateTime> = new EventEmitter();
  @Output() monthChanged: EventEmitter<DateTime> = new EventEmitter();
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  customHeader = CalendarHeaderComponent;
  dateFormat : string = 'yyyy-MM-dd'

  confirmConfig = {
    width: '550px',
    panelClass: 'asp-modal-container',
    disableClose:true,
    data: {popupTitle : 'otherTexts.appointmentOverrideConfirmation', popupBodyText: 'otherTexts.appointmentAvailabilityOverrideConfirmationMsg',clicked:true, 
    showAlert: true,
    saveButton: 'service.yes', cancelButton: 'service.no', overrideSelectedDate: 'dummy date'}
  };

  leavesLegend: any[];

  private control: AbstractControl;


  onChange: any = (value) => { };
  onTouched: any = () => { };

  constructor(@Optional() @Host() @SkipSelf()
  private readonly controlContainer: ControlContainer,
  private readonly dialog: MatDialog,
  private readonly translate: TranslateService,) {

    this.leavesLegend = [{ name: 'Holiday' },{ name: 'Day-off' }, { name: 'Training' }];

  }

  ngOnInit() {
    this.control = this.controlContainer.control.get(this.formControlName);
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.control.reset();
    }
  }

  registerOnTouched(fn) {
    //this.onTouched = fn;
  }

  get value(): DateTime {
    return this.control.value;
  }

  set value(value) {
    this.selectedDate = DateTime.fromFormat(value.toString(), this.dateFormat);
    if (this.calendar) {
      this.calendar.activeDate = this.selectedDate;
    }
    this.onChange(value);
    this.onTouched();
  }

  filterDate = (d: DateTime): boolean => {
    const currentDate = d.toFormat(this.dateFormat);

    if(DateTime.now().toFormat(this.dateFormat)===currentDate)
    {
      return this.availableDates?.filter(t => t === currentDate).length > 0;
    }
    return d.diffNow('days').days >= 0
      && this.availableDates?.filter(t => t === currentDate).length > 0;
  }

  dateFilterInput = this.filterDate;

  leaveTypeObj = {
    "NOT_IN_SCHEDULEROTATION": "NOT_IN_SCHEDULEROTATION",
    "WEEKLY": "WEEKLY",
    "BIWEEKLY": "BIWEEKLY",
    "TRAINING": "TRAINING",
    "DAY-OFF": "DAY-OFF",
    "MONTHLY": "MONTHLY"
  }

  setDateClass = (event: any) => {
    let classname = '';
    const date = event.toFormat(this.dateFormat);
    const offDate = this.closedDates.find((data)=> data.leaveDate === date);
    if(offDate) {
      return (this.leaveTypeObj[offDate.leaveType]) ? `mat-circle-calendar-body-cell circle-${offDate.leaveDayTime}${offDate.leaveType}` : "mat-circle-calendar-body-cell circle-DEFAULT"
    }

    classname += this.addLeaveService.dealerShipHoliday.find(x => x.date === date && x.dayType !== 'HALF') ? `dealershipholiday` : this.addLeaveService.dealerShipHoliday.find(x => x.date === date && x.dayType === 'HALF') ? `dealershipholiday${this.addLeaveService.dealerShipHoliday.find(x => x.date === date && x.dayType === 'HALF').dayTime}` : '';

    return `mat-circle-calendar-body-cell circle-class${classname}`;
  };

  dateChange(e) {
    this.control.setValue(e.toFormat(this.dateFormat));
    this.dateChanged.emit(e.toFormat(this.dateFormat));
  }

  validate(_: UntypedFormControl) {
    return this.control.valid ? null : { valid: false };
  }

  isDashBoard() {
    return this.source!== 'dashboard'? false: true;  
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('currentMonth')) {
      this.syncCalendarActiveDate();
    }

    if (changes.hasOwnProperty(('availableDates'))) {
      this.dateFilterInput = undefined;
      setTimeout( () => {
        this.dateFilterInput = this.filterDate;
        this.syncCalendarActiveDate();
      }, 0);
    }
  }

  private syncCalendarActiveDate() {
    if (!this.calendar) {
      return;
    }

    const activeMonth = this.getCurrentMonth();
    if (activeMonth) {
      this.calendar.activeDate = activeMonth.startOf('month');
    }
  }

  private getCurrentMonth(): DateTime | undefined {
    if (!this.currentMonth) {
      return undefined;
    }

    if (DateTime.isDateTime(this.currentMonth)) {
      return this.currentMonth;
    }

    if (this.currentMonth instanceof Date) {
      return DateTime.fromJSDate(this.currentMonth);
    }

    if (typeof this.currentMonth === 'string') {
      const parsedDate = DateTime.fromISO(this.currentMonth);
      return parsedDate.isValid ? parsedDate : undefined;
    }

    return undefined;
  }

  
  clickEvent(_type: string, _event) {
    if(this.selectedDate === undefined) {
      return
    }

    const dateSelected = this.selectedDate.toFormat(this.dateFormat);

    if(this.closedDates.findIndex((data)=> data.leaveDate === dateSelected) !== -1) {
      this.confirmConfig.data.overrideSelectedDate = dateSelected;
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {...this.confirmConfig});
      dialogRef.afterClosed().subscribe(event => { 
        this.notifyParent.emit(event);
      })
    }
    
  }

  getTranslation(name) {
    return name ? this.translate.instant(`common.${name}`) : name
  }

  monthChange(date: DateTime) {
    this.currentMonth = date.startOf('month');
    this.monthChanged.emit(this.currentMonth);
  }
}
